import { Group, Loader, Select, Text } from '@mantine/core';
import { usePlaygroundObjects } from '../../../queries/use-integrations-playground';
import { extractPlaygroundError } from '../../../api/integrations-playground-service';
import { PlaygroundErrorDisplay } from './playground-error-display';

interface PlaygroundObjectSelectProps {
  accountId: string;
  integrationKey: string;
  value: string | null;
  onChange: (value: string | null) => void;
  label?: string;
}

export function PlaygroundObjectSelect({
  accountId,
  integrationKey,
  value,
  onChange,
  label = 'Object type',
}: PlaygroundObjectSelectProps) {
  const { data, isLoading, isError, error } = usePlaygroundObjects(accountId, integrationKey);

  if (isError) {
    return <PlaygroundErrorDisplay error={extractPlaygroundError(error)} />;
  }

  const options = (data?.items ?? []).map((object) => ({
    value: object.name,
    label: object.label ? `${object.label} (${object.name})` : object.name,
  }));

  return (
    <div>
      <Select
        label={label}
        placeholder={isLoading ? 'Loading object types…' : 'Select an object type'}
        data={options}
        value={value}
        onChange={onChange}
        searchable
        nothingFound="No object types"
        disabled={isLoading}
        rightSection={isLoading ? <Loader size="xs" /> : undefined}
        maxDropdownHeight={320}
      />
      {data?.hasMore && (
        <Group spacing={4} mt={4}>
          <Text size="xs" color="dimmed">
            More object types exist (paginated). Showing the first page.
          </Text>
        </Group>
      )}
    </div>
  );
}
